import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import qs from 'qs';

import { Shift } from 'model/Shift';

import client from './client';
import { BaseResp, ShiftWorkListResp, ShiftWorkResp, UserAuthListResp, UserAuthResp, UserInfoListResp, UserInfoResp } from './response';
import { UserSearchRequest } from './searchRequest/UserSearchRequest';
import { UserSelectSearchRequest } from './searchRequest/UserSelectSearchRequest';

export const getUserInfoList = (
  req: UserSearchRequest | UserSelectSearchRequest,
): Promise<UserInfoListResp> => client.get('v1/user/list', { params: req });

export const getUserInfo = (): Promise<UserInfoResp> =>
  client.get('v1/account/info');

// 관리자 정보 변경
const editUser = (user: UserFormData): Promise<BaseResp> =>
  client.post('v1/account/info', { ...user });
export const useEditUserMutation = () => useMutation(editUser);

export interface UserFormData {
  name: string;
  // mobile: string;
}

// password 변겅
const editPass = (passwordFormData: PassFormData): Promise<BaseResp> =>
  client.post('v1/account/pass', { ...passwordFormData });
export const useEditPassMutation = () => useMutation(editPass);

export interface PassFormData {
  oldPass: string;
  newPass: string;
}

const registerSignImg = (image: string): Promise<BaseResp> =>
  client.post('v1/account/sign', { image });
export const useRegisterSignImgMutation = () => useMutation(registerSignImg);

const doubleCheckAccount = (account: string): Promise<BaseResp> =>
  client.post('v1/user/check', { account });
export const useDoubleCheckAccountMutation = () =>
  useMutation(doubleCheckAccount);

export const getUserAuthList = (
  req: UserSearchRequest,
): Promise<UserAuthListResp> => client.get('v1/auth/list', { params: req });
export const getUserAuth = (id: number): Promise<UserAuthResp> =>
  client.get(`v1/auth/${id}/locker`);
const editUserAuth = (req: UserAuthRequest) =>
  axios({
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/auth/${req.userId}`,
    method: 'POST',
    data: qs.stringify(
      { lockerIds: [...req.lockerIds] },
      { arrayFormat: 'repeat' },
    ),
    withCredentials: true,
  });
export const useEditUserAuthMutation = () => useMutation(editUserAuth);

// 교대근무 관리
export const getShiftWorkList = (): Promise<ShiftWorkListResp> => client.get('v1/shifts');
export const getShiftWork = (shiftId: number): Promise<ShiftWorkResp> => client.get(`v1/shift/${shiftId}`);

const registerShiftWork = (shiftWorkFormData: Shift): Promise<BaseResp> => client.post('v1/shift', { ...shiftWorkFormData });
export const useRegisterShiftWorkMutation = () => useMutation(registerShiftWork);

const updateShiftWork = (shiftWorkFormData: Shift): Promise<BaseResp> => client.post(`v1/shift/${shiftWorkFormData.shiftId}`, { ...shiftWorkFormData });
export const useUpdateShiftWorkMutation = () => useMutation(updateShiftWork);



type UserAuthForm = {
  name: string;
  id: number;
  activate: boolean;
};
export interface UserAuthFormData {
  userAuth: UserAuthForm[] | undefined;
  userId: number;
}

export interface UserAuthRequest {
  lockerIds: number[];
  userId: number;
}